import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useState, ReactNode } from "react";
import { typo } from "../../../assets/fonts/font";

interface ProductAccordionProps {
  title: string;
  children: ReactNode;
}

const ProductAccordion = ({ title, children }: ProductAccordionProps) => {
  const [icon, setIcon] = useState(false);
  return (
    <Accordion sx={{ backgroundColor: "inherit" }}>
      <AccordionSummary
        expandIcon={icon ? <RemoveIcon /> : <AddIcon />}
        aria-controls="panel2-content"
        id="panel2-header"
        onClick={() => setIcon(!icon)}
      >
        <Typography sx={{ ...typo.title }}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default ProductAccordion;
